export interface IHealthRecord {
	expectantMother?: boolean;
	physicalAbilityCondition?: boolean;
	confused?: boolean;
	hearing?: boolean;
	eyesight?: boolean;
	depression?: boolean;
	severePain?: boolean;
	excessiveDrowsiness?: boolean;
	epilepsy?: boolean;
	heart?: boolean;
	asthma?: boolean;
	mentalHealth?: boolean;
	allergies?: boolean;
	medication?: boolean;
	affectAbility?: boolean;
	notificationAgree?: boolean;
	healthIssuesDescription?: string;
	disabilityNeeds?: string;
	contagiousDiseases?: boolean;
	sasOptIn?: boolean;
	vaccinationMeasles?: boolean;
	vaccinationMumps?: boolean;
	vaccinationRubella?: boolean;
	vaccinationVaricella?: boolean;
	vaccinationTuberculosis?: boolean;
	vaccinationHepatitisB?: boolean;
	vaccinationHepatitisC?: boolean;
	vaccinationHIV?: boolean;
	vaccinationCovid?: boolean;
	vaccinationCovid1?: boolean;
	vaccinationCovid2?: boolean;
	vaccinationCovidBooster?: boolean;
	vaccinationCovidInfluenza?: boolean;
	fitToWorkOverride?: boolean;
}

export interface IHealthRecordErrors {
	healthIssuesError?: string;
	healthIssuesDescriptionError?: string;
	healthSignatureError?: string;
	healthDrawnSignatureError?: string;
}

export class HealthRecordModel {
	physicalAbilityCondition?: boolean;
	confused?: boolean;
	hearing?: boolean;
	eyesight?: boolean;
	depression?: boolean;
	severePain?: boolean;
	excessiveDrowsiness?: boolean;
	epilepsy?: boolean;
	heart?: boolean;
	asthma?: boolean;
	mentalHealth?: boolean;
	expectantMother?: boolean;
	allergies?: boolean;
	medication?: boolean;
	affectAbility?: boolean;
	notificationAgree?: boolean;
	healthIssuesDescription?: string;
	disabilityNeeds?: string;
	contagiousDiseases?: boolean;
	sasOptIn?: boolean;
	vaccinationMeasles?: boolean;
	vaccinationMumps?: boolean;
	vaccinationRubella?: boolean;
	vaccinationVaricella?: boolean;
	vaccinationTuberculosis?: boolean;
	vaccinationHepatitisB?: boolean;
	vaccinationHepatitisC?: boolean;
	vaccinationHIV?: boolean;
	vaccinationCovid?: boolean;
	vaccinationCovid1?: boolean;
	vaccinationCovid2?: boolean;
	vaccinationCovidBooster?: boolean;
	vaccinationCovidInfluenza?: boolean;
	fitToWorkOverride?: boolean;

	constructor(data?: IHealthRecord) {
		this.physicalAbilityCondition = data?.physicalAbilityCondition !== null && data?.physicalAbilityCondition !== undefined ? data?.physicalAbilityCondition : null;
		this.confused = data?.confused !== null && data?.confused !== undefined ? data?.confused : null;
		this.hearing = data?.hearing !== null && data?.hearing !== undefined ? data?.hearing : null;
		this.eyesight = data?.eyesight !== null && data?.eyesight !== undefined ? data?.eyesight : null;
		this.depression = data?.depression !== null && data?.depression !== undefined ? data?.depression : null;
		this.severePain = data?.severePain !== null && data?.severePain !== undefined ? data?.severePain : null;
		this.excessiveDrowsiness = data?.excessiveDrowsiness !== null && data?.excessiveDrowsiness !== undefined ? data?.excessiveDrowsiness : null;
		this.epilepsy = data?.epilepsy !== null && data?.epilepsy !== undefined ? data?.epilepsy : null;
		this.heart = data?.heart !== null && data?.heart !== undefined ? data?.heart : null;
		this.asthma = data?.asthma !== null && data?.asthma !== undefined ? data?.asthma : null;
		this.mentalHealth = data?.mentalHealth !== null && data?.mentalHealth !== undefined ? data?.mentalHealth : null;
		this.expectantMother = data?.expectantMother !== null && data?.expectantMother !== undefined ? data?.expectantMother : null;
		this.allergies = data?.allergies !== null && data?.allergies !== undefined ? data?.allergies : null;
		this.medication = data?.medication !== null && data?.medication !== undefined ? data?.medication : null;
		this.healthIssuesDescription = data?.healthIssuesDescription || "";
		this.disabilityNeeds = data?.disabilityNeeds || "";
		this.contagiousDiseases = data?.contagiousDiseases !== null && data?.contagiousDiseases !== undefined ? data?.contagiousDiseases : null;
		this.affectAbility = data?.affectAbility !== null && data?.affectAbility !== undefined ? data?.affectAbility : null;
		this.notificationAgree = data?.notificationAgree !== null && data?.notificationAgree !== undefined ? data?.notificationAgree : null;
		this.sasOptIn = data?.sasOptIn !== null && data?.sasOptIn !== undefined ? data?.sasOptIn : null;
		this.vaccinationMeasles = data?.vaccinationMeasles !== null && data?.vaccinationMeasles !== undefined ? data?.vaccinationMeasles : null;
		this.vaccinationMumps = data?.vaccinationMumps !== null && data?.vaccinationMumps !== undefined ? data?.vaccinationMumps : null;
		this.vaccinationRubella = data?.vaccinationRubella !== null && data?.vaccinationRubella !== undefined ? data?.vaccinationRubella : null;
		this.vaccinationVaricella = data?.vaccinationVaricella !== null && data?.vaccinationVaricella !== undefined ? data?.vaccinationVaricella : null;
		this.vaccinationTuberculosis = data?.vaccinationTuberculosis !== null && data?.vaccinationTuberculosis !== undefined ? data?.vaccinationTuberculosis : null;
		this.vaccinationHepatitisB = data?.vaccinationHepatitisB !== null && data?.vaccinationHepatitisB !== undefined ? data?.vaccinationHepatitisB : null;
		this.vaccinationHepatitisC = data?.vaccinationHepatitisC !== null && data?.vaccinationHepatitisC !== undefined ? data?.vaccinationHepatitisC : null;
		this.vaccinationHIV = data?.vaccinationHIV !== null && data?.vaccinationHIV !== undefined ? data?.vaccinationHIV : null;
		this.vaccinationCovid = data?.vaccinationCovid !== null && data?.vaccinationCovid !== undefined ? data?.vaccinationCovid : null;
		this.vaccinationCovid1 = data?.vaccinationCovid1 !== null && data?.vaccinationCovid1 !== undefined ? data?.vaccinationCovid1 : null;
		this.vaccinationCovid2 = data?.vaccinationCovid2 !== null && data?.vaccinationCovid2 !== undefined ? data?.vaccinationCovid2 : null;
		this.vaccinationCovidBooster = data?.vaccinationCovidBooster !== null && data?.vaccinationCovidBooster !== undefined ? data?.vaccinationCovidBooster : null;
		this.vaccinationCovidInfluenza = data?.vaccinationCovidInfluenza !== null && data?.vaccinationCovidInfluenza !== undefined ? data?.vaccinationCovidInfluenza : null;
		this.fitToWorkOverride = data?.fitToWorkOverride !== null && data?.fitToWorkOverride !== undefined ? data?.fitToWorkOverride : null;
	}
}
